import React, {Component} from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import {translate} from 'react-i18next';
import Help from '../../generics/help';
import { Table } from 'react-bootstrap';
import { LineChart, XAxis, YAxis, CartesianGrid, Legend, Line, Tooltip, ReferenceLine } from 'recharts';
import $ from 'jquery';

const Config = require('../../../config');

var session = sessionStorage.getItem('health_facilities_name');

class QualityControlReport extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.searching = this.searching.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.state = {
            start_date:"",
            end_date:"",
            stats:[],
            data:[],
            min:"",
            max:"",
            vol:"",
            responsable:"",
            bolsa:"",
            marca:"",
            lote:"",
            peso:"",
            densidad:"",
            balanza:""
        }
    }

    componentWillMount(){
		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id')
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

    componentDidMount(){
        
        fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});
        });
        
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){

				var fecha1 = moment(this.state.start_date);
				var fecha2 = moment(this.state.end_date);

                var dias = fecha2.diff(fecha1, 'days');
                
                var obj = {
                    health_facilities_id: sessionStorage.getItem('health_facilities_id'),
                    start_date: this.state.start_date,
                    end_date: this.state.end_date   
                }

				if(dias <= 31){
                    this.props.waiting.handleShow('Buscando...');
                    fetch(Config.default.apiGateway.URL+'reports/st_report', {
                        method : 'POST',
                        body:JSON.stringify(obj),						
						headers : new Headers({
							'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
							'Content-Type': 'application/json'
						})
					})
					.then(res => {
						this.props.waiting.handleClose();
						if(res.ok){
							return res.json();
						}else{
							res.text().then((msg)=>{
								swal('Error', msg, 'error');
							});
						}
					})
					.then(response => {
						
						if (response !== undefined && response !== null) { 
							var stats = [
                                {title:'Cantidad (n)', prom:response.stats.count_prom, total: response.stats.count_total},
                                {title:'Volumen promedio (ml)', prom:response.stats.volume_prom, total: response.stats.volume_total},
                                {title:'Desviación estandar', prom:response.stats.sd_prom, total: response.stats.sd_total}
                            ];

                            
                            this.setState({
                                stats: stats, 
                                data: response.list_units,
                                min: response.stats.vol_min,
                                max: response.stats.vol_max
                            });
						}
							
					})
				}else{
					this.props.waiting.handleClose();
					swal('Error', 'La diferencia entre las fechas es de '+dias+' dias, la diferencia maxima entre la fecha desde y la fecha hasta debe ser de 40 dias', 'error')
				}

				
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}

		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
    }
    
    handleClick(e){
        this.setState({
            vol:"",
            responsable:"",
            bolsa:"",
            marca:"",
            lote:"",
            peso:"",
            densidad:"",
            balanza:""
        });
        var id = e.payload.id;
        fetch(Config.default.apiGateway.URL+'quality_control/st_bag?id='+id,{
            method:"GET",
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.setState({
                    vol:response.volume,
                    responsable: response.user_extraction,
                    bolsa: response.bag_name,
                    marca: response.brand_name,
                    lote: response.lot_number,
                    peso: response.bag_weight,
                    densidad: response.density,
                    balanza:response.balance
                });
            }
        })
    }

    render(){
    	const {t} = this.props;
        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Control de Calidad ->
					Volumen de Sangre Total
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_general_information"}  />

				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required  />
								</div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>
                            <div className="col-xs-12 col-sm-10">
                                <div className="col-xs-12 col-sm-12 form-group" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
                                    <span>
                                        Volumen de Sangre Total
                                    </span>
                                </div>
                                <div className="col-xs-12 form-group">
                                    <div className="col-xs-12 col-sm-5">
                                        <Table responsive hover>
                                            <thead>
                                                <tr>
                                                    <th>Propiedad</th>
                                                    <th>Diario</th>
                                                    <th>Acumulado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.stats.map((s, i)=>
                                                    <tr key={i}>
                                                        <td>{s.title}</td>
                                                        <td>{s.prom}</td>
                                                        <td>{s.total}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                
                                    <div className="col-xs-12 col-sm-7">
                                        <table style={{width:'100%'}}>
                                            <tbody>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>Volumen de extracción (ml)</td>
                                                    <td>{this.state.vol}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>Responsable extracción</td>
                                                    <td>{this.state.responsable}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>Bolsa</td>
                                                    <td>{this.state.bolsa}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>Marca</td>
                                                    <td>{this.state.marca}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>Lote</td>
                                                    <td>{this.state.lote}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>Peso de la bolsa vacía</td>
                                                    <td>{this.state.peso}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>Densidad</td>
                                                    <td>{this.state.densidad}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{fontWeight:'bold'}}>Balanza</td>
                                                    <td>{this.state.balanza}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-xs-12 grafica">
                                    <LineChart
                                        width={$('.grafica').width() - 100}
                                        height={300}
                                        data={this.state.data}
                                        margin={{
                                        top: 20, right: 50, left: 20, bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="name" padding={{ left: 30, right: 30 }} />
                                        <YAxis />
                                        <Legend />
                                        <Tooltip content={<div className="tooltip-info"></div>} active={false}/>
                                        <ReferenceLine y={this.state.min} stroke="red" label="Min" />
                                        <ReferenceLine y={this.state.max} label="Max" stroke="red" />
                                        <Line type="monotone" dataKey="volume" stroke="#8884d8" 
                                            activeDot={{
                                                onClick: (event, payload)=> this.handleClick(payload),
                                                onMouseOver: (event, payload)=>$('.tooltip-info').html(payload.payload.unit_number),
                                                onMouseLeave: ()=>$('.tooltip-info').html('')
                                            }}
                                            
                                        />
                                    </LineChart>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate('translations')(QualityControlReport);